import React, { useEffect, useState } from 'react'
import { Breadcrumbs, Button, InsideFooter, Search } from '../../../components'
import { PaginationOrder } from '../../../constants/pagination'
import useHistory from '../../../hooks/useHistory'
import { useInfinitePagination } from '../../../hooks/useInfinitePagination'
import ecbrApi from '../../../services/ecbrApi'
import LocalStorageService from '../../../services/LocalStorageService'
import {
  BoxContainer,
  BoxBrand,
  BoxButton
} from '../../Admin/Companies/Brands/styles'
import { Container, Top } from '../../Admin/styles'
import { DefaultUserPage } from '../../DefaultPages'
import PlusIcon from '../../../assets/Icons/PlusIcon'
import { Roles } from '../../../constants/roles'

const pagination = { page: 1, take: 10 }

const UserBrands = () => {
  const user = LocalStorageService.get('user') || {}
  const history = useHistory()
  const [error, setError] = useState('')
  const [searchParameters, setSearchParameters] = useState({
    ...pagination,
    order: PaginationOrder.ASC,
    name: '',
    cnpj: user.companies?.[0]?.cnpj || '',
    urlWebsite: ''
  })

  const {
    data: brands,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'usersBrands',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.brands.getActualCompanyBrands({
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParameters])

  const handleSearch = (value) => {
    setSearchParameters({
      ...searchParameters,
      name: value,
      page: pagination.page
    })
  }

  const handleClickBrand = (brandId) => {
    history.push(`/user/brands/${brandId}`)
  }

  return (
    <DefaultUserPage page="brands">
      <Container>
        <Top>
          <Breadcrumbs />
          {/* <Button
            type="button"
            variant="outlined"
            text="Exportar excel"
            width="120px"
          /> */}
        </Top>
        <h3>Aqui você pode gerenciar todas as certificações das suas lojas</h3>
        <Search
          placeholder="pesquisar loja"
          onSearch={handleSearch}
          search={searchParameters.name}
          setSearch={(value) =>
            setSearchParameters({ ...searchParameters, name: value })
          }
        />
        <BoxContainer>
          {isLoading && <p>Carregando...</p>}
          {error && <p>{error}</p>}
          {brands?.map?.((brand) => (
            <BoxBrand key={brand.id} onClick={() => handleClickBrand(brand.id)}>
              <h3>{brand.brandName}</h3>
              <p>{brand.urlWebsite}</p>
            </BoxBrand>
          ))}
          {hasNextPage && !isLastPage && (
            <Button
              type="button"
              variant="outlined"
              text={isLoading || isFetching ? 'Carregando...' : 'Ver mais'}
              width="200px"
              height="40px"
              onClick={fetchNextPage}
            />
          )}
          {user.role === Roles.ADMIN_USER && (
            <BoxButton onClick={() => history.push('/user/new-brand')}>
              <PlusIcon disabled={isLoading || isFetching} />
            </BoxButton>
          )}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultUserPage>
  )
}

export default UserBrands
